module.exports = __webpack_public_path__ + "static/img/diease-right.ed82b0f5.png";